import React from 'react';
import Footer from '../components/Footer';

const Terms: React.FC = () => {
  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ background: 'linear-gradient(to bottom, #0c0d1f, #1b1324)' }}
    >
      <div className="flex-1 px-6 md:px-12 lg:px-20 py-12">
        <div className="max-w-4xl mx-auto space-y-8 bg-white/5 border border-white/10 rounded-3xl p-8 backdrop-blur">
          <div>
            <p className="text-primary-200 text-sm uppercase tracking-wide mb-2">Terms &amp; Conditions</p>
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">AdSmash Terms of Service</h1>
            <p className="text-white/70">Effective Date: May 01, 2024</p>
          </div>

          <section className="space-y-3 text-white/80">
            <p>
              These Terms of Service (“Terms”) govern your use of the AdSmash website, browser extension, mobile
              applications, and premium services (collectively, the “Services”). By installing or using AdSmash, you
              agree to these Terms and to our Privacy Policy. If you do not agree, do not use the Services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">1. Eligibility & accounts</h2>
            <p className="text-white/80">
              You must be at least 16 years old (or the age of majority where you reside) to use AdSmash. Certain
              features require an account; you are responsible for maintaining the confidentiality of your credentials
              and for all activity under your account.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">2. Subscriptions & billing</h2>
            <ul className="list-disc pl-6 space-y-2 text-white/80">
              <li>AdSmash Premium is billed in advance according to the plan you select.</li>
              <li>Introductory promotions (such as 70% off for the first year) apply only to the specified term.</li>
              <li>You may cancel at any time; your benefits remain active through the end of the paid period.</li>
              <li>We offer a 30-day money-back guarantee on first-time premium purchases. Contact support@adsmash.com to request a refund.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">3. License & acceptable use</h2>
            <p className="text-white/80 mb-3">
              AdSmash grants you a limited, revocable, non-transferable license to install and use the extension or apps
              solely for personal, non-commercial purposes. You agree not to:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-white/80">
              <li>Reverse engineer, decompile, or attempt to extract the source code of the Services.</li>
              <li>Sell, rent, sublicense, or exploit the Services for commercial gain without prior written consent.</li>
              <li>Use the Services to violate any law, infringe third-party rights, or introduce malware.</li>
              <li>Interfere with or disrupt any servers, networks, or security features related to AdSmash.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">4. Intellectual property</h2>
            <p className="text-white/80">
              AdSmash and all related names, logos, and content are the property of AdSmash, Inc. or its licensors. All
              rights not expressly granted in these Terms are reserved.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">5. Termination</h2>
            <p className="text-white/80">
              We may suspend or terminate your access to the Services at any time if you breach these Terms or misuse the
              Services. You may also stop using AdSmash at any time. Sections that by their nature should survive
              termination (e.g., intellectual property, disclaimers, limitation of liability) will remain in effect.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">6. Disclaimers</h2>
            <p className="text-white/80">
              AdSmash is provided “as is” without warranties of any kind, either express or implied, including but not
              limited to warranties of merchantability, fitness for a particular purpose, or non-infringement. We do not
              guarantee that the Services will block every advertisement, remain error-free, or be available at all times.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">7. Limitation of liability</h2>
            <p className="text-white/80">
              To the maximum extent permitted by law, AdSmash, Inc. and its affiliates shall not be liable for any
              indirect, incidental, special, consequential, or punitive damages, or any loss of profits or data, arising
              from your use of the Services. Our total cumulative liability for any claim shall not exceed the amount you
              paid to us in the 12 months preceding the claim (or USD $50 if you use the free extension).
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">8. Indemnity</h2>
            <p className="text-white/80">
              You agree to defend, indemnify, and hold harmless AdSmash, Inc., its officers, directors, employees, and
              agents from any claims, damages, liabilities, and expenses arising from your use of the Services or your
              violation of these Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">9. Changes to the Services or Terms</h2>
            <p className="text-white/80">
              We may update the Services or these Terms at any time. When we make material changes, we’ll notify you via
              email or by posting a notice on our website. Your continued use of AdSmash after changes become effective
              constitutes acceptance of the updated Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">10. Governing law</h2>
            <p className="text-white/80">
              These Terms are governed by the laws of the State of California, without regard to conflict-of-law
              principles. Any disputes will be resolved exclusively in the state or federal courts located in San
              Francisco County, California, and you consent to the jurisdiction of those courts.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">11. Contact us</h2>
            <p className="text-white/80">
              Questions about these Terms? Email <a href="mailto:support@adsmash.com" className="text-primary-300">support@adsmash.com</a> or
              write to AdSmash, Inc., 1200 Market Street, Suite 230, San Francisco, CA 94102 USA.
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Terms;

